import { render, staticRenderFns } from "./UploadMassivePatients.vue?vue&type=template&id=f466cdd0&scoped=true"
import script from "./UploadMassivePatients.vue?vue&type=script&lang=ts"
export * from "./UploadMassivePatients.vue?vue&type=script&lang=ts"
import style0 from "./UploadMassivePatients.vue?vue&type=style&index=0&id=f466cdd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f466cdd0",
  null
  
)

export default component.exports